import React, { useRef, forwardRef, useImperativeHandle } from 'react'
import intl from 'react-intl-universal'
import { useAppSelector } from '@/store/hooks'
import BusinessCard from '@/components/BusinessCard/BusinessCard'
import type { BusinessCardRefProps } from '@/components/BusinessCard/BusinessCard'
import type { globalTypes } from '@/store/store.d'
import styles from './BusinessCardDetail.module.scss'

export type BusinessCardDetailProps = {
  ctaId?: number,
  global?: globalTypes,
}

export type BusinessCardDetailRefProps = {
  updateBusinessCard: () => void,
}

const BusinessCardDetail = forwardRef<BusinessCardDetailRefProps, BusinessCardDetailProps>((props, childRef) => {
  const { ctaId } = props
  const global = useAppSelector((state: any) => state.global)

  const businessCardref = useRef<BusinessCardRefProps>(null)

  useImperativeHandle(childRef, () => ({
    // 更新名片信息
    updateBusinessCard: () => {
      businessCardref?.current?.updateBusinessCard()
    }
  }))

  return(
    <div className={styles['business-card-detail']}>
      <div className={styles['info-hd']}>
        <h3 className={styles['hd-title']}>{intl.get('user_info.detail_title')}</h3>
      </div>
      <div className={styles['info-bd']}>
        {
          ctaId && <BusinessCard ref={businessCardref} ctaId={ctaId}/>
        }
      </div>
    </div>
  )
});

export default BusinessCardDetail